module.exports = "/_next/static/images/payments_3-0244262dd4eb613d894adcfb43a3f737.png";